<template>
    <el-select v-model="outletModel" fit-input-width reserve-keyword label="pickup" :placeholder="$t('chooseBranch')"
        @change="findOutlet" class="__kfc_orderType_select __kfc_r_7" :class="classes">
        <el-option v-for="outlet in outlets" :key="outlet" :label="locale === 'mn' ? outlet.name_mn : outlet.name_en"
            :value="outlet.outletname" />
    </el-select>
</template>

<script>
import Req from '@/utils/Request';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex'
import { useGtm } from '@gtm-support/vue-gtm';
export default {
    props: ['value', 'classes'],
    setup (props) {
        const store = useStore()
        const gtm = useGtm();
        const { value, classes } = props
        const locale = computed(() => store.getters.locale)
        const pickupAddress = computed(() => store.getters['address/getPickupAddress']);
        const outlets = computed(() => store.getters['menu/getOutlets']);
        const outletModel = ref(value === "KFC-Virtual" ? '' : value);
        const selectedStore = ref();

        watch(pickupAddress, (newdata, olddata) => {
            // address.value = newdata;
            outletModel.value = newdata;
            //     if (default_outlet.value === pickupAddress.value) {
            //         outletModel.value = ''
            //         selectedStore.value = '';
            //     } else {
            //         outletModel.value = pickupAddress.value
            //         selectedStore.value = pickupAddress.value;
            //     }
        })

        // watch(pickupAddress, () => {
        //     if (default_outlet.value === pickupAddress.value) {
        //         outletModel.value = ''
        //         selectedStore.value = '';
        //     } else {
        //         outletModel.value = pickupAddress.value
        //         selectedStore.value = pickupAddress.value;
        //     }
        // })

        const getOutlets = async () => {
            if (outlets.value.length === 0) {
                const { data: result } = await Req({ url: '/manager/getOutlets', hideSuccess: true })
                if (result.success) {
                    store.dispatch('menu/setOutlets', result.result)
                }
            }

        }
        const checkOutlets = async (outletname) => {
            // const { outletname } = outlet
            const { data: result } = await Req({ url: '/manager/getOutletByOutletName', body: { outlet_name: outletname }, hideSuccess: true })
            if (result.success) {
                store.dispatch('address/updatePickupAddress', result.result.outletname)
                localStorage.setItem('endTimeStore', result.result.end_time)
                gtm.trackEvent({
                    event: 'selected_store',
                    action: 'selected',
                    value: result.result.outletname
                });
            } else {
                //toast message gargah
            }
        }

        const findOutlet = () => {
            selectedStore.value = outlets.value.find(x => x.outletname === outletModel.value)
            checkOutlets(selectedStore.value.outletname)
        }
        onMounted(() => {
            getOutlets()
        })
        return {
            selectedStore, outletModel, locale, outlets, classes, findOutlet
        }
    }
}
</script>

<style lang="scss"></style>